module.exports = __webpack_public_path__ + "img/pp-de-logo.a2926fe2.png";